// Auto-generated TypeScript for ObservableItemIdentifier
// Usage:
// import { ObservableItemIdentifier } from './ObservableItemIdentifier';
// const identifier = ObservableItemIdentifier.Identifiers.Bucket.Condition.WearKit.Measurement.Position.Value;
class ObservableItemIdentifier {
    static Identifiers = {
            Bucket: {
                    Condition: {
                            WearKit: {
                                    Measurement: {
                                            Position: {
                                                    Value: "Bucket.Condition.WearKit.Measurement.Position.Value"
                                            },
                                            Tool: "Bucket.Condition.WearKit.Measurement.Tool"
                                    },
                                    Summary: {
                                            Comments: "Bucket.Condition.WearKit.Summary.Comments",
                                            Photo: "Bucket.Condition.WearKit.Summary.Photo",
                                            Completed: "Bucket.Condition.WearKit.Summary.Completed"
                                    },
                                    WearPlates: {
                                            Location: {
                                                    Comments: "Bucket.Condition.WearKit.WearPlates.Location.Comments",
                                                    Photo: "Bucket.Condition.WearKit.WearPlates.Location.Photo"
                                            },
                                            Summary: {
                                                    Comments: "Bucket.Condition.WearKit.WearPlates.Summary.Comments",
                                                    Photo: "Bucket.Condition.WearKit.WearPlates.Summary.Photo"
                                            },
                                    },
                            },
                    },
                    GroundEngagingTools: {
                            ChangeOut: {
                                    Position: {
                                            TotalBases: "Bucket.GroundEngagingTools.ChangeOut.Position.TotalBases",
                                            TotalParts: "Bucket.GroundEngagingTools.ChangeOut.Position.TotalParts",
                                            TotalPins: "Bucket.GroundEngagingTools.ChangeOut.Position.TotalPins"
                                    },
                                    Reason: {
                                            Damaged: {
                                                    Checked: "Bucket.GroundEngagingTools.ChangeOut.Reason.Damaged.Checked",
                                                    Value: "Bucket.GroundEngagingTools.ChangeOut.Reason.Damaged.Value"
                                            },
                                            Missing: {
                                                    Checked: "Bucket.GroundEngagingTools.ChangeOut.Reason.Missing.Checked",
                                                    Value: "Bucket.GroundEngagingTools.ChangeOut.Reason.Missing.Value"
                                            },
                                            Worn: {
                                                    Checked: "Bucket.GroundEngagingTools.ChangeOut.Reason.Worn.Checked",
                                                    Value: "Bucket.GroundEngagingTools.ChangeOut.Reason.Worn.Value"
                                            },
                                    },
                                    Specification: {
                                            NewParts: {
                                                    Checked: "Bucket.GroundEngagingTools.ChangeOut.Specification.NewParts.Checked"
                                            },
                                            SameParts: {
                                                    Checked: "Bucket.GroundEngagingTools.ChangeOut.Specification.SameParts.Checked"
                                            },
                                            PartId: "Bucket.GroundEngagingTools.ChangeOut.Specification.PartId"
                                    },
                                    PartHours: "Bucket.GroundEngagingTools.ChangeOut.PartHours"
                            },
                            Condition: {
                                    Measurement: {
                                            Length: "Bucket.GroundEngagingTools.Condition.Measurement.Length",
                                            Thickness: "Bucket.GroundEngagingTools.Condition.Measurement.Thickness",
                                            Tool: "Bucket.GroundEngagingTools.Condition.Measurement.Tool",
                                            Value: "Bucket.GroundEngagingTools.Condition.Measurement.Value"
                                    },
                                    WearIndicators: {
                                            Base: {
                                                    Damaged: "Bucket.GroundEngagingTools.Condition.WearIndicators.Base.Damaged",
                                                    Missing: "Bucket.GroundEngagingTools.Condition.WearIndicators.Base.Missing"
                                            },
                                            Part: {
                                                    Damaged: "Bucket.GroundEngagingTools.Condition.WearIndicators.Part.Damaged",
                                                    Missing: "Bucket.GroundEngagingTools.Condition.WearIndicators.Part.Missing"
                                            },
                                            Pin: {
                                                    Damaged: "Bucket.GroundEngagingTools.Condition.WearIndicators.Pin.Damaged",
                                                    LooseAndRetightened: "Bucket.GroundEngagingTools.Condition.WearIndicators.Pin.LooseAndRetightened",
                                                    Missing: "Bucket.GroundEngagingTools.Condition.WearIndicators.Pin.Missing"
                                            },
                                    },
                                    Comments: "Bucket.GroundEngagingTools.Condition.Comments",
                                    Photo: "Bucket.GroundEngagingTools.Condition.Photo"
                            },
                            Location: {
                                    Summary: {
                                            Comments: "Bucket.GroundEngagingTools.Location.Summary.Comments",
                                            Photo: "Bucket.GroundEngagingTools.Location.Summary.Photo",
                                            Completed: "Bucket.GroundEngagingTools.Location.Summary.Completed"
                                    },
                            },
                            Summary: {
                                    Comments: "Bucket.GroundEngagingTools.Summary.Comments",
                                    Photo: "Bucket.GroundEngagingTools.Summary.Photo",
                                    Completed: "Bucket.GroundEngagingTools.Summary.Completed"
                            },
                    },
                    Installation: {
                            InstallDate: "Bucket.Installation.InstallDate",
                            MachineHours: "Bucket.Installation.MachineHours"
                    },
                    Location: {
                            Customer: "Bucket.Location.Customer",
                            Site: "Bucket.Location.Site",
                            Machine: "Bucket.Location.Machine",
                            MineLocation: "Bucket.Location.MineLocation"
                    },
                    Specifications: {
                            CapitalIndexNumber: "Bucket.Specifications.CapitalIndexNumber",
                            CustomerBucketName: "Bucket.Specifications.CustomerBucketName",
                            Fitment: "Bucket.Specifications.Fitment",
                            Manufacturer: "Bucket.Specifications.Manufacturer",
                            PartNumber: "Bucket.Specifications.PartNumber",
                            SerialNumber: "Bucket.Specifications.SerialNumber"
                    },
                    Structural: {
                            Summary: {
                                    Comments: "Bucket.Structural.Summary.Comments",
                                    Photo: "Bucket.Structural.Summary.Photo"
                            },
                    },
                    Summary: {
                            Comments: "Bucket.Summary.Comments",
                            Photo: "Bucket.Summary.Photo",
                            Completed: "Bucket.Summary.Completed"
                    },
                    IsNew: "Bucket.IsNew",
                    ExternalId: "Bucket.ExternalId",
                    IsChangeOut: "Bucket.IsChangeOut",
                    ChangeOutFrom: "Bucket.ChangeOutFrom"
            },
            CoverPhoto: {
                    Completed: "CoverPhoto.Completed",
                    Photo: "CoverPhoto.Photo"
            },
            ExecutiveSummary: {
                    Comments: "ExecutiveSummary.Comments",
                    Completed: "ExecutiveSummary.Completed"
            },
            LockOff: {
                    Completed: "LockOff.Completed",
                    LockedOff: "LockOff.LockedOff",
                    NotifiedCustomer: "LockOff.NotifiedCustomer"
            },
            LockOn: {
                    Completed: "LockOn.Completed",
                    CompletedSigned: "LockOn.CompletedSigned",
                    IsolatedMachine: "LockOn.IsolatedMachine",
                    TimeLockOn: "LockOn.TimeLockOn"
            },
            MachineOverview: {
                    Comments: "MachineOverview.Comments"
            },
            Operation: {
                    UndercarriagePropelHours: {
                            Left: "Operation.UndercarriagePropelHours.Left",
                            Right: "Operation.UndercarriagePropelHours.Right"
                    },
                    UndercarriageChangeOut: {
                            Left: {
                                    Checked: "Operation.UndercarriageChangeOut.Left.Checked",
                                    Date: "Operation.UndercarriageChangeOut.Left.Date",
                                    MachineHoursAtChange: "Operation.UndercarriageChangeOut.Left.MachineHoursAtChange"
                            },
                            Right: {
                                    Checked: "Operation.UndercarriageChangeOut.Right.Checked",
                                    Date: "Operation.UndercarriageChangeOut.Right.Date",
                                    MachineHoursAtChange: "Operation.UndercarriageChangeOut.Right.MachineHoursAtChange"
                            },
                    },
                    PitCondition: {
                            CurrentDiggingConditions: "Operation.PitCondition.CurrentDiggingConditions",
                            DiggingConditionsSinceLastInspection: "Operation.PitCondition.DiggingConditionsSinceLastInspection",
                            TotalBankCubicMeters: "Operation.PitCondition.TotalBankCubicMeters",
                            TotalTonnage: "Operation.PitCondition.TotalTonnage"
                    },
                    Completed: "Operation.Completed",
                    TotalMachineHours: "Operation.TotalMachineHours",
                    TotalPropelHours: "Operation.TotalPropelHours"
            },
            Undercarriage: {
                    DriveLug: {
                            WearIndicators: {
                                    Delamination: "Undercarriage.DriveLug.WearIndicators.Delamination",
                                    DelaminationShoes: "Undercarriage.DriveLug.WearIndicators.DelaminationShoes",
                                    PlasticDeformation: "Undercarriage.DriveLug.WearIndicators.PlasticDeformation",
                                    SevereCracking: "Undercarriage.DriveLug.WearIndicators.SevereCracking",
                                    Spalling: "Undercarriage.DriveLug.WearIndicators.Spalling",
                                    SpallingDelaminationMinorCracking: "Undercarriage.DriveLug.WearIndicators.SpallingDelaminationMinorCracking",
                                    StructuralCracking: "Undercarriage.DriveLug.WearIndicators.StructuralCracking",
                                    ToenailingContact: "Undercarriage.DriveLug.WearIndicators.ToenailingContact",
                                    ToenailingContactShoes: "Undercarriage.DriveLug.WearIndicators.ToenailingContactShoes"
                            },
                            WornLength: {
                                    Measurement: "Undercarriage.DriveLug.WornLength.Measurement"
                            },
                            Comments: "Undercarriage.DriveLug.Comments",
                            Photo: "Undercarriage.DriveLug.Photo"
                    },
                    DriveTumbler: {
                            DriveLug: {
                                    Completed: "Undercarriage.DriveTumbler.DriveLug.Completed"
                            },
                            Engagement: {
                                    Completed: "Undercarriage.DriveTumbler.Engagement.Completed"
                            },
                            RollerPath: {
                                    Completed: "Undercarriage.DriveTumbler.RollerPath.Completed"
                            },
                    },
                    Hardware: {
                            WearIndicators: {
                                    Damaged: "Undercarriage.Hardware.WearIndicators.Damaged",
                                    Loose: "Undercarriage.Hardware.WearIndicators.Loose",
                                    Missing: "Undercarriage.Hardware.WearIndicators.Missing"
                            },
                            Photo: "Undercarriage.Hardware.Photo"
                    },
                    Idler: {
                            Front: {
                                    Completed: "Undercarriage.Idler.Front.Completed",
                                    VisualCondition: "Undercarriage.Idler.Front.VisualCondition"
                            },
                            Rear: {
                                    Completed: "Undercarriage.Idler.Rear.Completed",
                                    VisualCondition: "Undercarriage.Idler.Rear.VisualCondition"
                            },
                            WearIndicators: {
                                    Collapsed: "Undercarriage.Idler.WearIndicators.Collapsed",
                                    ExcessAxleBoreClearance: "Undercarriage.Idler.WearIndicators.ExcessAxleBoreClearance",
                                    ExcessiveGuideFaceClearance: "Undercarriage.Idler.WearIndicators.ExcessiveGuideFaceClearance",
                                    Leaking: "Undercarriage.Idler.WearIndicators.Leaking",
                                    LooseOrMissingRetainingHardware: "Undercarriage.Idler.WearIndicators.LooseOrMissingRetainingHardware",
                                    RollerPathCrackingDelaminationPlasticDeformation: "Undercarriage.Idler.WearIndicators.RollerPathCrackingDelaminationPlasticDeformation",
                                    SevereCracking: "Undercarriage.Idler.WearIndicators.SevereCracking",
                                    ThrustWasherDamagedOrMissing: "Undercarriage.Idler.WearIndicators.ThrustWasherDamagedOrMissing"
                            },
                            Comments: "Undercarriage.Idler.Comments",
                            Photo: "Undercarriage.Idler.Photo"
                    },
                    Roller: {
                            WearIndicators: {
                                    BuriedWithMedia: "Undercarriage.Roller.WearIndicators.BuriedWithMedia",
                                    Collapsed: "Undercarriage.Roller.WearIndicators.Collapsed",
                                    ExcessiveAxleBoreClearance: "Undercarriage.Roller.WearIndicators.ExcessiveAxleBoreClearance",
                                    FlatSpot: "Undercarriage.Roller.WearIndicators.FlatSpot",
                                    FlatSpotWear: "Undercarriage.Roller.WearIndicators.FlatSpotWear",
                                    Leaking: "Undercarriage.Roller.WearIndicators.Leaking",
                                    LooseMissingRetainingHardware: "Undercarriage.Roller.WearIndicators.LooseMissingRetainingHardware",
                                    PedestalDamageWeldCracking: "Undercarriage.Roller.WearIndicators.PedestalDamageWeldCracking",
                                    RollerPathCrackingDelaminationPlasticDeformation: "Undercarriage.Roller.WearIndicators.RollerPathCrackingDelaminationPlasticDeformation",
                                    SevereCracking: "Undercarriage.Roller.WearIndicators.SevereCracking",
                                    SideframeDamage: "Undercarriage.Roller.WearIndicators.SideframeDamage",
                                    SlidePathCrackingDelaminationPlasticDeformation: "Undercarriage.Roller.WearIndicators.SlidePathCrackingDelaminationPlasticDeformation",
                                    ThrustWasherDamagedMissing: "Undercarriage.Roller.WearIndicators.ThrustWasherDamagedMissing"
                            },
                            Comments: "Undercarriage.Roller.Comments",
                            Photo: "Undercarriage.Roller.Photo",
                            VisualCondition: "Undercarriage.Roller.VisualCondition"
                    },
                    RollerAssemblies: {
                            LoadRoller: {
                                    Completed: "Undercarriage.RollerAssemblies.LoadRoller.Completed"
                            },
                            ReturnRoller: {
                                    Completed: "Undercarriage.RollerAssemblies.ReturnRoller.Completed"
                            },
                            Slider: {
                                    Completed: "Undercarriage.RollerAssemblies.Slider.Completed"
                            },
                    },
                    RollerPath: {
                            Wear: {
                                    Measurement: "Undercarriage.RollerPath.Wear.Measurement"
                            },
                            WearIndicators: {
                                    SevereCracking: {
                                            Checked: "Undercarriage.RollerPath.WearIndicators.SevereCracking.Checked",
                                            Value: "Undercarriage.RollerPath.WearIndicators.SevereCracking.Value"
                                    },
                                    SpallingDelaminationMinorCracking: {
                                            Checked: "Undercarriage.RollerPath.WearIndicators.SpallingDelaminationMinorCracking.Checked",
                                            Value: "Undercarriage.RollerPath.WearIndicators.SpallingDelaminationMinorCracking.Value"
                                    },
                                    Toenailing: {
                                            Checked: "Undercarriage.RollerPath.WearIndicators.Toenailing.Checked",
                                            Value: "Undercarriage.RollerPath.WearIndicators.Toenailing.Value"
                                    },
                            },
                            Comments: "Undercarriage.RollerPath.Comments",
                            Photo: "Undercarriage.RollerPath.Photo"
                    },
                    Shoes: {
                            DriveLug: {
                                    WearIndicators: {
                                            PlasticDeformation: {
                                                    Checked: "Undercarriage.Shoes.DriveLug.WearIndicators.PlasticDeformation.Checked",
                                                    Value: "Undercarriage.Shoes.DriveLug.WearIndicators.PlasticDeformation.Value"
                                            },
                                            SevereCracking: {
                                                    Checked: "Undercarriage.Shoes.DriveLug.WearIndicators.SevereCracking.Checked",
                                                    Value: "Undercarriage.Shoes.DriveLug.WearIndicators.SevereCracking.Value"
                                            },
                                            SpallingDelaminationMinorCracking: {
                                                    Checked: "Undercarriage.Shoes.DriveLug.WearIndicators.SpallingDelaminationMinorCracking.Checked",
                                                    Value: "Undercarriage.Shoes.DriveLug.WearIndicators.SpallingDelaminationMinorCracking.Value"
                                            },
                                    },
                                    Completed: "Undercarriage.Shoes.DriveLug.Completed"
                            },
                            PitchExtension: {
                                    PitchGauge: {
                                            CalculatedPitchGauge: "Undercarriage.Shoes.PitchExtension.PitchGauge.CalculatedPitchGauge",
                                            Measurement: "Undercarriage.Shoes.PitchExtension.PitchGauge.Measurement"
                                    },
                                    TapeMeasure: {
                                            CalculatedTapePitchExtension: "Undercarriage.Shoes.PitchExtension.TapeMeasure.CalculatedTapePitchExtension",
                                            Measurement: "Undercarriage.Shoes.PitchExtension.TapeMeasure.Measurement",
                                            NumberOfShoes: "Undercarriage.Shoes.PitchExtension.TapeMeasure.NumberOfShoes"
                                    },
                                    WearIndicators: {
                                            Bushings: {
                                                    Cracking: {
                                                            Checked: "Undercarriage.Shoes.PitchExtension.WearIndicators.Bushings.Cracking.Checked",
                                                            Value: "Undercarriage.Shoes.PitchExtension.WearIndicators.Bushings.Cracking.Value"
                                                    },
                                                    Loss: {
                                                            Checked: "Undercarriage.Shoes.PitchExtension.WearIndicators.Bushings.Loss.Checked",
                                                            Value: "Undercarriage.Shoes.PitchExtension.WearIndicators.Bushings.Loss.Value"
                                                    },
                                                    Walking: {
                                                            Checked: "Undercarriage.Shoes.PitchExtension.WearIndicators.Bushings.Walking.Checked",
                                                            Value: "Undercarriage.Shoes.PitchExtension.WearIndicators.Bushings.Walking.Value"
                                                    },
                                                    Missing: "Undercarriage.Shoes.PitchExtension.WearIndicators.Bushings.Missing"
                                            },
                                            Hardware: {
                                                    Damage: {
                                                            Checked: "Undercarriage.Shoes.PitchExtension.WearIndicators.Hardware.Damage.Checked",
                                                            Value: "Undercarriage.Shoes.PitchExtension.WearIndicators.Hardware.Damage.Value"
                                                    },
                                                    Loose: {
                                                            Checked: "Undercarriage.Shoes.PitchExtension.WearIndicators.Hardware.Loose.Checked",
                                                            Value: "Undercarriage.Shoes.PitchExtension.WearIndicators.Hardware.Loose.Value"
                                                    },
                                                    Missing: {
                                                            Checked: "Undercarriage.Shoes.PitchExtension.WearIndicators.Hardware.Missing.Checked",
                                                            Value: "Undercarriage.Shoes.PitchExtension.WearIndicators.Hardware.Missing.Value"
                                                    },
                                            },
                                            PinBoreLugs: {
                                                    AbnormalWear: {
                                                            Checked: "Undercarriage.Shoes.PitchExtension.WearIndicators.PinBoreLugs.AbnormalWear.Checked",
                                                            Value: "Undercarriage.Shoes.PitchExtension.WearIndicators.PinBoreLugs.AbnormalWear.Value"
                                                    },
                                                    Broken: {
                                                            Checked: "Undercarriage.Shoes.PitchExtension.WearIndicators.PinBoreLugs.Broken.Checked",
                                                            Value: "Undercarriage.Shoes.PitchExtension.WearIndicators.PinBoreLugs.Broken.Value"
                                                    },
                                                    Cracking: {
                                                            Checked: "Undercarriage.Shoes.PitchExtension.WearIndicators.PinBoreLugs.Cracking.Checked",
                                                            Value: "Undercarriage.Shoes.PitchExtension.WearIndicators.PinBoreLugs.Cracking.Value"
                                                    },
                                            },
                                            Pins: {
                                                    Broken: {
                                                            Checked: "Undercarriage.Shoes.PitchExtension.WearIndicators.Pins.Broken.Checked",
                                                            Value: "Undercarriage.Shoes.PitchExtension.WearIndicators.Pins.Broken.Value"
                                                    },
                                                    CheckTension: {
                                                            Checked: "Undercarriage.Shoes.PitchExtension.WearIndicators.Pins.CheckTension.Checked",
                                                            Value: "Undercarriage.Shoes.PitchExtension.WearIndicators.Pins.CheckTension.Value"
                                                    },
                                                    VisibleGap: {
                                                            Checked: "Undercarriage.Shoes.PitchExtension.WearIndicators.Pins.VisibleGap.Checked",
                                                            Value: "Undercarriage.Shoes.PitchExtension.WearIndicators.Pins.VisibleGap.Value"
                                                    },
                                                    GapAmount: "Undercarriage.Shoes.PitchExtension.WearIndicators.Pins.GapAmount"
                                            },
                                    },
                                    Completed: "Undercarriage.Shoes.PitchExtension.Completed",
                                    Comments: "Undercarriage.Shoes.PitchExtension.Comments",
                                    Photo: "Undercarriage.Shoes.PitchExtension.Photo"
                            },
                            RollerPath: {
                                    WearIndicators: {
                                            SevereCracking: {
                                                    Checked: "Undercarriage.Shoes.RollerPath.WearIndicators.SevereCracking.Checked",
                                                    Value: "Undercarriage.Shoes.RollerPath.WearIndicators.SevereCracking.Value"
                                            },
                                            SpallingDelaminationMinorCracking: {
                                                    Checked: "Undercarriage.Shoes.RollerPath.WearIndicators.SpallingDelaminationMinorCracking.Checked",
                                                    Value: "Undercarriage.Shoes.RollerPath.WearIndicators.SpallingDelaminationMinorCracking.Value"
                                            },
                                            Toenailing: {
                                                    Checked: "Undercarriage.Shoes.RollerPath.WearIndicators.Toenailing.Checked",
                                                    Value: "Undercarriage.Shoes.RollerPath.WearIndicators.Toenailing.Value"
                                            },
                                    },
                                    Completed: "Undercarriage.Shoes.RollerPath.Completed"
                            },
                    },
                    SideFrame: {
                            Comments: "Undercarriage.SideFrame.Comments",
                            Completed: "Undercarriage.SideFrame.Completed",
                            Photo: "Undercarriage.SideFrame.Photo"
                    },
                    TumblerEngagement: {
                            Comments: "Undercarriage.TumblerEngagement.Comments",
                            Photo: "Undercarriage.TumblerEngagement.Photo"
                    },
            },
    };
}

export { ObservableItemIdentifier };
